import Keycloak from "keycloak-js";
export const keycloak = new Keycloak({
  url: "https://gilead-auth.indegene.com/auth/",
  clientId: "NCCA",
  realm: "NCCA-GILEAD-PROD", 
});

